// PatientTable.jsx
import React, { useState, useEffect } from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    IconButton,
    Link
} from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';

const PatientTable = () => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [data, setData] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await fetch('https://sperms.ailab.vn:5008/api/patients');
            const result = await response.json();
            setData(result);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleString('vi-VN');
    };

    const downloadReport = (reportPath) => {
        window.open(`https://sperms.ailab.vn:5008/${reportPath}`, '_blank');
    };

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Mã bệnh nhân</TableCell>
                            <TableCell>Tên bệnh nhân</TableCell>
                            <TableCell>Mã mẫu</TableCell>
                            <TableCell>Ngày lấy mẫu</TableCell>
                            <TableCell>Mã báo cáo</TableCell>
                            <TableCell>Tải báo cáo</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row) => (
                                <TableRow hover key={row.patient_id}>
                                    <TableCell>{row.patient_id}</TableCell>
                                    <TableCell>{row.patient_name}</TableCell>
                                    <TableCell>{row.sample_id}</TableCell>
                                    <TableCell>{formatDate(row.collection_date)}</TableCell>
                                    <TableCell>{row.report_id}</TableCell>
                                    <TableCell>
                                        {row.report_path !== "" && (
                                            <IconButton
                                                color="primary"
                                                onClick={() => downloadReport(row.report_path)}
                                            >
                                                <DownloadIcon />
                                            </IconButton>
                                        )}
                                        
                                    </TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={data.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage="Số hàng mỗi trang:"
            />
        </Paper>
    );
};

export default PatientTable;